<section>
  <div *ngIf="showTickets">
    <div *ngIf="(!showCartMobile && isMobile) || !isMobile">
      <div class="days-wrapper">
        <button type="button" class="btn go-next" (click)="goNext()">
          <img
            src="assets/images/tickets/right.svg"
            style="transform: rotate(180deg)"
          />
        </button>
        <div class="event-days" #eventDaysEl>
          <ng-container *ngFor="let day of eventDays; let i = index">
            <div
              class="event-days__day"
              [class.selected]="selectedDayIndex - 1 === i"
              (click)="selectDay(i, day)"
              [id]="'day-' + i"
              *ngIf="hidePreviousDays(day)"
            >
              <span>{{ day.startAt * 1000 | date : "dd" }}</span>
              <span class="date">
                {{
                  day.startAt * 1000
                    | localizedDate : "MMM" : translate.currentLang
                }}
                <br />
                {{ day.startAt * 1000 | date : "y" }}
              </span>
            </div>
            <div class="event-days__day" *ngIf="!day">
              <span>
                <span class="skeleton-box"></span>
              </span>
              <span class="skeleton-box"></span>
            </div>
          </ng-container>
        </div>
        <button type="button" class="btn go-prev" (click)="goPrev()">
          <img src="assets/images/tickets/right.svg" />
        </button>
      </div>
    </div>
    <div *ngIf="selectedDayIndex" style="margin-top: 5%">
      <app-book-title
        *ngIf="(!showCartMobile && isMobile) || !isMobile"
        booktitle="chooseTicket"
        info="info-ticket"
      ></app-book-title>
      <div class="row mt-4 mobile-ticket-card">
        <div
          *ngIf="(!showCartMobile && isMobile) || !isMobile"
          class="col-lg-7 col-md-12 col-12"
        >
          <ng-container *ngFor="let schedule of schedules">
            <app-ticket-card
              *ngIf="schedule?.ticket?.status != 'INACTIVE'"
              [ticketSchedule]="schedule"
              [schedule]="eventDays[selectedDayIndex - 1]"
            ></app-ticket-card>
          </ng-container>
        </div>
        <div *ngIf="!isMobile" class="col-lg-1"></div>
        <div
          class="col-lg-4 col-md-12 col-12"
          *ngIf="!isMobile || (showCartMobile && isMobile)"
        >
          <div
            *ngIf="
              this.ticketService?.bookTicket?.getValue()?.items?.length == 0 ||
              !this.ticketService?.bookTicket?.getValue()?.items
            "
          >
            <div class="no-tickets-card">
              <img src="assets/images/tickets/no-tickets.png" />
              <p>{{ "no-ticket" | translate }}</p>
            </div>
          </div>
          <div
            *ngIf="
              this.ticketService?.bookTicket?.getValue()?.items?.length > 0
            "
          >
            <div class="cart">
              <app-cart></app-cart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
